import React, { useContext, useEffect, useState } from "react";
import UserContext from "../auth/UserContext";
import LocationDropdown from "./LocationDropdown";
import PodiumDropdown from "./PodiumDropdown";
import { toast } from "react-toastify";
import "./PodiumSelector.css";

const PodiumSelector = () => {
    const { userDetail, activePodiumId, activeLocationId, selectPodium } = useContext(UserContext);

    const [locationId, setLocationId] = useState("");
    const [podiumId, setPodiumId] = useState("");

    useEffect(() => {
        setLocationId(activeLocationId || "");
        setPodiumId(activePodiumId || "");
    }, [activeLocationId, activePodiumId]);

    const locations = userDetail?.accessibleLocations || [];
    const allPodiums = userDetail?.accessiblePodiums || [];
    const podiumsAtLocation = allPodiums.filter((p) => Number(p.locationId) === Number(locationId));

    const handleSubmit = (e) => {
        e.preventDefault();
        const selected = allPodiums.find((p) => Number(p.id) === Number(podiumId));
        if (!selected) {
            toast.error("Please select a podium", { autoClose: 1000 });
            return;
        }
        selectPodium(selected.id, selected.locationId);
        toast.success(`Active podium set to ${selected.name}`, { autoClose: 1000 });
    };

    return (
        <div className="podium-selector-page">
            <div className="podium-selector-card">
                <h2 className="podium-selector-title">Select Location & Podium</h2>
                <form
                    className="podium-selector-form"
                    onSubmit={handleSubmit}>
                    <div className="podium-selector-row">
                        <LocationDropdown
                            locations={locations}
                            selectedLocationId={locationId}
                            onChange={(id) => {
                                setLocationId(Number(id) || "");
                                setPodiumId("");
                            }}
                        />
                    </div>

                    <div className="podium-selector-row">
                        <PodiumDropdown
                            podiums={podiumsAtLocation}
                            selectedPodiumId={podiumId}
                            onChange={(id) => setPodiumId(Number(id))}
                        />
                    </div>

                    <button
                        type="submit"
                        className="podium-selector-btn"
                        disabled={!podiumId}>
                        Set Active
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PodiumSelector;
